const header = document.querySelector('#shopify-section-sections--25312847135056__header');
let isScrolled = false;

window.addEventListener('scroll', function() {
    if (window.scrollY > 0 && !isScrolled) {
        header.classList.add('user_scroll');
        isScrolled = true;
    } else if (window.scrollY === 0 && isScrolled) {
        header.classList.remove('user_scroll');
        isScrolled = false;
    }
});